import axios from 'axios';

const api = axios.create({
    baseURL: 'http://packiot4back-env.eba-tejvmvxf.us-east-2.elasticbeanstalk.com/'
});

export default api;